import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Klicke auf die Schaltfläche unten, um deine Zahlungsinformationen zu überprüfen und zu bestätigen.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Wir arbeiten mit Stripe zusammen, um Zahlungen abzuwickeln. Stripe ist die sicherste Zahlungsplattform, die von den größten Unternehmen weltweit genutzt wird.',
      form: {
        terms_acceptance: {
          label:
            'Indem Sie fortfahren, erklären Sie sich mit unserer <FoodAmigosTerms>Dienstleistungsvereinbarung</FoodAmigosTerms> und der <StripeTerms>Stripe Connected Account-Vereinbarung</StripeTerms> einverstanden.',
        },
      },
      labels: {
        stripe_requirements:
          'Stripe hat einige Kundeninformationen als fehlend oder ungültig markiert. Bitte beheben Sie folgende Fehler, indem Sie auf die Schaltfläche "Stripe-Profil öffnen" klicken:',
        errors: 'Fehler',
        awaiting_verification: 'Dein Stripe-Konto wird überprüft',
        awaiting_verification_description:
          'Wir warten darauf, dass Stripe die Überprüfung deines Unternehmens abschließt. In der Zwischenzeit kannst du dein Profil einsehen.',
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Für die Zahlungsabwicklung arbeiten wir mit Adyen zusammen. Adyen ist eine der sichersten Zahlungsplattformen, die von den größten Unternehmen weltweit genutzt wird.',
    },
  },
  labels: {
    verified: 'Dein {{paymentGateway}}-Konto ist verifiziert',
    verified_description:
      'Die Verifizierung von {{paymentGateway}} ist abgeschlossen. Du kannst dein Profil bei Bedarf weiterhin verwalten.',
  },
  buttons: {
    proceed: 'Bestätige meine Zahlungsinformationen',
    copy_link: 'Link kopieren',
  },
  toasts: {
    something_went_wrong: 'Etwas ist schief gelaufen, bitte kontaktieren Sie den technischen Support',
  },
};
